const getFormText = (count: number) =>
  count === 1 ? 'formulier' : 'formulieren';

export default getFormText;
